import { Component } from '@angular/core';
import { MatTab, MatTabGroup } from '@angular/material/tabs';
import { ClientEventListnerComponent } from '@app/components/admin/client-event-listner/client-event-listner.component';
import { SimComponent } from '@app/components/admin/sim/sim.component';
import { PageLayoutComponent } from '@app/components/shared/page-layout/page-layout.component';
import { RagComponent } from '@app/components/admin/rag/rag.component';

@Component({
  selector: 'faxe-admin-home',
  imports: [
    MatTab,
    MatTabGroup,
    ClientEventListnerComponent,
    SimComponent,
    PageLayoutComponent,
    RagComponent
  ],
  templateUrl: './admin-home.component.html',
  styleUrl: './admin-home.component.scss'
})
export class AdminHomeComponent {

}
